import { JsonValue } from '@/utils/transformation';

import { LOCAL_STORAGE_KEYS, SESSION_STORAGE_KEYS } from '../constants/storage-keys';
import { parseJsonOrFallback } from './text';

export function getLocalStorageItem(
	key: string,
	parseJson: boolean = false
): string | null | JsonValue {
	if (typeof window === 'undefined') return null;

	const output = localStorage.getItem(key);

	if (!parseJson) return output;
	return parseJsonOrFallback(output ?? '', null);
}

export function setLocalStorageItem(key: LOCAL_STORAGE_KEYS, value: string): void {
	if (typeof window === 'undefined') return;

	localStorage.setItem(key as unknown as string, value);
}

export function removeLocalStorageItem(key: LOCAL_STORAGE_KEYS): void {
	if (typeof window === 'undefined') return;
	localStorage.removeItem(key as unknown as string);
}

export function clearLocalStorage(): void {
	if (typeof window === 'undefined') return;
	localStorage.clear();
}

export function getSessionStorageItem(key: SESSION_STORAGE_KEYS): string | null {
	if (typeof window === 'undefined') return null;
	return sessionStorage.getItem(key);
}

export function setSessionStorageItem(key: SESSION_STORAGE_KEYS, value: string): void {
	if (typeof window === 'undefined') return;
	sessionStorage.setItem(key, value);
}

export function removeSessionStorageItem(key: SESSION_STORAGE_KEYS): void {
	if (typeof window === 'undefined') return;
	sessionStorage.removeItem(key);
}

export function clearSessionStorage(): void {
	if (typeof window === 'undefined') return;
	sessionStorage.clear();
}
